export default __webpack_public_path__ + "static/media/youtube-colored-icon.2b793ac9.svg";